import { ShieldAlert } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { RiskFlag } from './types';

type Props = {
  flags: RiskFlag[];
};

export function RiskFlagsAlert({ flags }: Props) {
  if (flags.length === 0) return null;

  return (
    <Card semantic="emergency">
      <CardHeader>
        <CardTitle headingLevel="h3" className="flex items-center gap-2">
          <ShieldAlert className="size-4" />
          Segnali di attenzione
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {flags.map((flag, i) => (
            <li key={i} className="flex items-start gap-2 text-sm">
              <Badge variant={flag.severity === 'high' ? 'emergency' : 'secondary'} className="mt-0.5 shrink-0">
                {flag.severity === 'high' ? 'Alto' : 'Medio'}
              </Badge>
              <div>
                <span>{flag.flag}</span>
                {flag.source ? (
                  <span className="text-muted-foreground ml-1 text-xs">({flag.source})</span>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
